// extracted by mini-css-extract-plugin
export default {"input":"Search-module__input__KcCbd_g"};